import React, { Fragment, useState } from 'react'
import { arrow_tip } from '../../../assets/images'

const ContentDropDown = ({ title, description, pointers, pointerHeaders = [''], classes = '' }) => {
  const [flag, setFlag] = useState(false)

  return (
    <div className={'pb-6 border-b border-gray-200 cursor-pointer ' + classes} onClick={() => setFlag((flag) => !flag)}>
      <div className='flex justify-between items-center'>
        <h1 className='mb-0 mr-1 text-base text-gray-700 font-semibold'>{title}</h1>
        <img src={arrow_tip} alt='dropdown-icon' className={`inline-block ${flag ? 'rotate-180 transform' : ''}`} />
      </div>
      {flag && (
        <Fragment>
          <p className='mb-0 text-gray-600 mt-3 mr-8'>{description}</p>
          {pointers &&
            pointerHeaders.map((item, ind) => (
              <Fragment>
                <p className='mb-0 text-gray-600 mt-3 mr-8'>{item}</p>
                {pointers[ind].map((item) => (
                  <div className='text-gray-600 mt-1 mr-8 flex'>
                    <li></li>
                    {item}
                  </div>
                ))}
              </Fragment>
            ))}
        </Fragment>
      )}
    </div>
  )
}

export default ContentDropDown
